/* esling-disable */
import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from 'hooks';
import { PrivateLayout } from 'layouts';
import { ConfigurationListPage } from 'pages/configuration/list';
import { RootState } from 'store';

import urls from './privateRoutesConfig';
import publicUrls from './urls';
import InferenceReports from 'pages/reports';
import { TrainPage } from 'pages/train';
import LiveInference from 'pages/inference/LiveInference';
import PickAndPlace from 'pages/train/pickAndPlace';
import ActivityAnnotationPage from 'pages/configuration/activityAnnotation';
import UploadTrainVideos from 'pages/train/Videos';
import WorkflowMonitor from 'pages/train/WorkflowConfig';
import ActivityFlow from 'pages/train/pickAndPlace/activityFlow/ActivityFlow';

const PrivateRoutes = () => {
  const { isLoggedIn } = useAppSelector((state: RootState) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(publicUrls.LOGIN.generate());
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn && location.pathname.startsWith('/auth')) {
      const url = '/configuration';
      navigate(url);
    }
  }, []);

  return (
    <PrivateLayout>
      <Routes>
        {Object.values(urls).map(route => {
          if (route.items) {
            return Object.values(route.items).map(subRoute => {
              return (
                <Route
                  key={subRoute.name}
                  path={`${route.route}${subRoute.route}`}
                  element={subRoute.component}
                />
              );
            });
          }
          return (
            <Route
              key={route.name}
              path={route.route}
              element={route.component}
            />
          );
        })}
        <Route path="/configuration/list" element={<ConfigurationListPage />} />

        <Route path="/train" element={<TrainPage />} />
        <Route path="/inference/live" element={<LiveInference />} />
        <Route
          path="/train/pick_&_place_annotation"
          element={<PickAndPlace />}
        />
        <Route
          path="/train/pick_&_place_annotation/activity_mapping"
          element={<ActivityFlow />}
        />
        <Route
          path="/train/activity_annotation"
          element={<ActivityAnnotationPage />}
        />
        <Route
          path="/inference/recorded/reports"
          element={<InferenceReports />}
        />
        <Route
          path="/train/workflowconfig/:flowtype"
          element={<WorkflowMonitor />}
        />
        <Route path="/train/videos" element={<UploadTrainVideos />} />

        <Route path="*" element={<ConfigurationListPage />} />
      </Routes>
    </PrivateLayout>
  );
};

export default PrivateRoutes;
